import { Status } from "./Status";

export class DisposalStatusSmartEnum {
    static Draft = new Status("Draft", 1, "pill--yellow");
    static ToPick = new Status("To Pick", 2, "pill--orange");
    static Queued = new Status("Queued", 3, "pill--blue");
    static Complete = new Status("Complete", 4, "pill--green");
    static Cancelled = new Status("Cancelled", 5, "pill--red");
    static Failed = new Status("Failed", 6, "pill--red");

    public static getName() {
        // Cannot use this.name as it will be the minified value in production
        return "DisposalStatusSmartEnum";
    }
}
